<template>
  <div>
    <!-- 头部 -->
    <headbox></headbox>

    <platform-content></platform-content>
    <!-- 底部 -->
    <footbox></footbox>
  </div>
</template>

<script>
import headbox from './components/home/headbox' 

import footbox from './components/footbox'
import platformContent from './components/platformContent'
export default {
  components: {
    footbox,
    headbox,
    platformContent
  },
}
</script>

<style lang="less" scoped>
</style>